export const ELECTRON_WORKOS_CALLBACK_SCHEME = 'smartmanager';
export const PUBLIC_AUTHORIZATION_REQUEST_TIMEOUT_MS = 15_000;

export function parseSafeWorkosAuthorizationUrl(value: unknown): URL | null {
  if (typeof value !== 'string' || !value.trim()) return null;
  try {
    const url = new URL(value);
    const isLocalHttp = url.protocol === 'http:' &&
      (url.hostname === 'localhost' || url.hostname === '127.0.0.1');
    if ((url.protocol !== 'https:' && !isLocalHttp) || url.username || url.password) return null;
    return url;
  } catch {
    return null;
  }
}

export function buildWorkosAuthorizeUrl({
  baseUrl,
  isElectron,
  recoveryAttempted,
  reauth,
  browserHandoff,
  timestamp = Date.now(),
}: {
  baseUrl: string;
  isElectron: boolean;
  /**
   * Desktop only: sign-in runs in the system browser, which stays open after
   * the app takes over. The callback then shows a finished page in that tab.
   */
  browserHandoff?: boolean;
  recoveryAttempted?: true;
  /** Step-up: ask AuthKit to re-authenticate even with a live session. */
  reauth?: true;
  timestamp?: number;
}) {
  const params = new URLSearchParams();
  if (isElectron) {
    params.set('desktop', 'true');
    params.set('callbackScheme', ELECTRON_WORKOS_CALLBACK_SCHEME);
    params.set('desktopExchange', 'pkce');
    if (browserHandoff) params.set('desktopHandoff', 'page');
  }
  if (!isElectron && recoveryAttempted) {
    params.set('recoveryAttempted', '1');
  }
  if (reauth) params.set('reauth', '1');
  params.set('_t', String(timestamp));

  return `${baseUrl}/api/auth/workos/authorize?${params.toString()}`;
}
